/**
 * Action categories that have a dedicated chip colour (see the `colors` mixin in
 * `styles/partials/_type-badge.scss`). Slugs, so a multi-word category such as "Add Note" is
 * `add-note`. Anything the API sends outside this list falls back to the neutral `default` chip.
 */
export const TYPE_BADGE_CLASSES = [
  'view',
  'print',
  'export',
  'approve',
  'deny',
  'proxy',
  'override',
  'add-note',
  'admin',
  'login',
];

/**
 * Slugified chip-colour class suffix for a server-composed action category, shared by the audit
 * feed's "Type" column and the detail screens' heading chip so the same event reads the same
 * colour in both places. Returns `default` for an empty value or a category with no dedicated
 * colour — a new API category renders neutral rather than unstyled.
 */
export function toTypeBadgeClass(typeCategory: string): string {
  // Slugified so multi-word categories ("Add Note") stay a single class token.
  const normalized = typeCategory.trim().toLowerCase().replace(/\s+/g, '-');
  return TYPE_BADGE_CLASSES.includes(normalized) ? normalized : 'default';
}
